<template>
  <div>
    Explore
  </div>
</template>

<script>
export default {};
</script>

<style></style>
